module.exports = __webpack_public_path__ + "img/bg06.f1a68d75.png";